import * as React from 'react';
import { Typography, Container, Accordion, AccordionSummary, AccordionDetails, List, ListItem, ListItemIcon, ListItemText, } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CheckIcon from '@mui/icons-material/Check';
import '../App.css';


const Imprint = () => {
  return (
    <div className="App">

      <main>

        <Container maxWidth="md" className="container serviceContainer">
          <Typography variant='h1' className='sectionTitle'>Karriere</Typography>

          <Typography variant='body1' className='sectionText'>
            Wir suchen Verstärkung für unser Team! Hier finden Sie Informationen zu den von uns angebotenen offenen Stellen. Wir sind gespannt auf Ihre Bewerbungsunterlagen und freuen uns darauf, Sie kennenzulernen.
          </Typography>

   
          <Accordion className='AccordionWrapper'>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel3-content"
              id="panel3-header">
              Notar(fach)angestellte (m/w/d) und/oder Leitende Notarmitarbeitende/Notarfachwirte (m/w/d) im Notarbüro Holland & Kreußlein in Oranienburg
            </AccordionSummary>
            <AccordionDetails className='accordionBody'>
              <Typography variant='body1' className='sectionText'>
              Wir, die Notare Holland & Kreußlein, suchen ab sofort und unbefristet Notar(fach)angestellte (m/w/d) für unser Büro in Oranienburg. Werden Sie Teil eines modernen und serviceorientierten Notarbüros!
              </Typography>
              <Typography variant='h3' className='subtitleh3small'>Ihre Aufgaben</Typography>
              <Typography variant='body1' className='sectionText'>
              Sie arbeiten gerne im Team, sind zuverlässig und kommunikativ, sorgfältig und gut belastbar.
              </Typography>
              <Typography variant='body1' className='sectionText'>
              Ein gepflegter Umgang mit Menschen ist für Sie selbstverständlich. Sie arbeiten selbstständig und organisiert.
              </Typography>
              <Typography variant='body1' className='sectionText'>
              Gerne bringen Sie Erfahrungen in einem der notarrelevanten Rechtsgebiete (Erb- und Familienrecht, Immobilienrecht, Gesellschaftsrecht) mit und können Urkundsentwürfe vorbereiten und vollziehen sowie die dazugehörigen Kostenrechnungen erstellen.
              </Typography>
              <Typography variant='h3' className='subtitleh3small'>Ihre Qualifikationen</Typography>
              <Typography variant='body1' className='sectionText'>
              Wir freuen uns über eine abgeschlossene Ausbildung als Notarfachangestellte (m/w/d) oder höhere Qualifikationen (etwa Leitender Notarmitarbeiter, Notarfachwirt, Notarfachreferent, jeweils m/w/d) und/oder entsprechende berufliche Erfahrungen im Notariat. Gerne können Sie sich auch für den Quer- oder Wiedereinstieg bewerben.
              </Typography>
              <Typography variant='body1' className='sectionText'>
              Sie sind geschickt im Umgang mit gängigen Office-Programmen und idealerweise auch mit Notarsoftwares und XNP.
              </Typography>
              <Typography variant='h3' className='subtitleh3small'>Unser Angebot</Typography>
              <Typography variant='body1' className='sectionText'>
              Wir bieten Ihnen ein abwechslungsreiches Aufgabenfeld in verantwortungsvoller Position in Oranienburg (ggf. anteilig in Hohen Neuendorf).
              </Typography>
              <Typography variant='body1' className='sectionText'>
              Die Arbeitszeit ist nach Absprache flexibel einteilbar; anteiliges Home-Office ist möglich. 
              </Typography>
              <Typography variant='body1' className='sectionText'>
              Eine leistungsgerechte, attraktive Vergütung ist selbstverständlich, ebenso eine modernste Ausstattung Ihres Arbeitsplatzes. Zudem profitieren Sie von weiteren Leistungen (etwa Guthabenkarte, betriebliche Altersvorsorge).
              </Typography>
              <Typography variant='body1' className='sectionText'>
              Wir bieten zudem regelmäßig die Möglichkeit zu internen und externen Fort- und Weiterbildungen.
              </Typography>
              <Typography variant='h3' className='subtitleh3small'>Ihre Bewerbung</Typography>
              <Typography variant='body1' className='sectionText'>
              Haben Sie Interesse? Schreiben Sie gerne eine E-Mail an <a href="mailto:buchhaltung@holland-kreusslein.de">buchhaltung@holland-kreusslein.de</a> – wir freuen uns auf Ihre Bewerbung!
              </Typography>
            </AccordionDetails>
          </Accordion>


          <Accordion className='AccordionWrapper'>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel2-content"
              id="panel2-header">
              Mitarbeitende am Empfang (m/w/d) im Notarbüro Holland & Kreußlein in Oranienburg
            </AccordionSummary>
            <AccordionDetails className='accordionBody'>
              <Typography variant='body1' className='sectionText'>
                Wir, die Notare Holland & Kreußlein, suchen ab sofort und unbefristet Mitarbeitende am Empfang (m/w/d) für unser Büro in Oranienburg. Werden Sie Teil eines modernen und serviceorientierten Notarbüros!
              </Typography>
              <Typography variant='h3' className='subtitleh3small'>Ihre Aufgaben</Typography>
              <Typography variant='body1' className='sectionText'>
                Sie arbeiten gerne im Team, sind zuverlässig und kommunikativ, sorgfältig und gut belastbar.
              </Typography>
              <Typography variant='body1' className='sectionText'>
                Ein gepflegter Umgang mit Menschen ist für Sie selbstverständlich. Sie arbeiten selbstständig und organisiert.
              </Typography>
              <Typography variant='body1' className='sectionText'>
                Gerne bringen Sie Erfahrungen in Empfangstätigkeiten und/oder Kundenbetreuung mit.
              </Typography>
              <Typography variant='h3' className='subtitleh3small'>Unser Angebot</Typography>
              <Typography variant='body1' className='sectionText'>
              Wir bieten Ihnen ein abwechslungsreiches Aufgabenfeld in verantwortungsvoller Position in Oranienburg (ggf. anteilig in Hohen Neuendorf).
              </Typography>
              <Typography variant='body1' className='sectionText'>
              Die Arbeitszeit ist nach Absprache flexibel einteilbar.
              </Typography>
              <Typography variant='body1' className='sectionText'>
              Eine leistungsgerechte, attraktive Vergütung ist selbstverständlich, ebenso eine modernste Ausstattung Ihres Arbeitsplatzes. Zudem profitieren Sie von weiteren Leistungen (etwa Guthabenkarte, betriebliche Altersvorsorge).
              </Typography>
              <Typography variant='body1' className='sectionText'>
              Wir bieten zudem regelmäßig die Möglichkeit zu internen und externen Fort- und Weiterbildungen.
              </Typography>
              <Typography variant='h3' className='subtitleh3small'>Ihre Bewerbung</Typography>
              <Typography variant='body1' className='sectionText'>
              Haben Sie Interesse? Schreiben Sie gerne eine E-Mail an <a href="mailto:buchhaltung@holland-kreusslein.de">buchhaltung@holland-kreusslein.de</a> – wir freuen uns auf Ihre Bewerbung!
              </Typography>
            </AccordionDetails>
          </Accordion>



          <Accordion className='AccordionWrapper'>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1-content"
              id="panel1-header">
              Studentische Mitarbeitende (m/w/d) im Notarbüro Holland & Kreußlein in Oranienburg
            </AccordionSummary>
            <AccordionDetails className='accordionBody'>
              <Typography variant='body1' className='sectionText'>
                Wir, die Notare Holland & Kreußlein, suchen ab sofort studentische Mitarbeitende (m/w/d) für unser Büro in Oranienburg.
              </Typography>
              <Typography variant='h3' className='subtitleh3small'>Ihre Aufgaben</Typography>
              <Typography variant='body1' className='sectionText'>
                Sie unterstützen uns bei den praktischen Arbeitsabläufen nach Beurkundung und erhalten einen Einblick in die Arbeitsweise und die Inhalte der notariellen Tätigkeiten. Neben Kopier- und Scanarbeiten betreuen Sie dabei insbesondere auch die Digitale Notarplattform (DiNo) und empfangen und betreuen ankommende Mandanten. Werden Sie Teil eines modernen und serviceorientierten Notarbüros und lernen Sie dabei auch den wohl schönsten juristischen Beruf kennen!
              </Typography>
              <Typography variant='h3' className='subtitleh3small'>Ihre Qualifikationen</Typography>
              <Typography variant='body1' className='sectionText'>
                Sie arbeiten gerne im Team, sind zuverlässig und kommunikativ, sorgfältig und gut belastbar. Ein gepflegter Umgang mit Menschen ist für Sie selbstverständlich. Sie arbeiten selbstständig und organisiert. Die Ausschreibung richtet sich ausdrücklich an Studierende aller Fächer, juristische Vorkenntnisse sind nicht erforderlich.
              </Typography>
              <Typography variant='h3' className='subtitleh3small'>Unser Angebot</Typography>
              <Typography variant='body1' className='sectionText'>
                Wir bieten Ihnen ein sich am TVstud der Berliner Universitäten orientierendes Gehalt. Die Arbeitszeit ist nach Absprache flexibel einteilbar, gerne auch am Nachmittag/Abend. Auch die wöchentliche Stundenanzahl ist frei nach Ihren Wünschen vereinbar.
              </Typography>
              <Typography variant='body1' className='sectionText'>
                Haben Sie Interesse? Schreiben Sie gerne eine E-Mail an <a href="mailto:buchhaltung@holland-kreusslein.de">buchhaltung@holland-kreusslein.de</a>.
              </Typography>
            </AccordionDetails>
          </Accordion>

          {/* 
        <Typography variant='body1' className='sectionText'>
        Ihre Bewerbung richten Sie bitte per E-Mail an <a href="mailto:info@holland-kreusslein.de">info@holland-kreusslein.de</a> oder auf dem Postweg an das Notarbüro Prenzlauer Straße 11 in 16515 Oranienburg.
          </Typography> */}

        </Container>

      </main >
    </div >
  );
}

export default Imprint;